













































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import ReportMainChart from '@/components/billing/ReportMainChart.vue';
import PieChart from '@/components/billing/PieChart.vue';
import Datepicker from 'vuejs-datepicker';
import { addMinutes, format, startOfMonth, subDays, subMinutes } from 'date-fns';
import * as FileSaver from 'file-saver';
import { billingService } from '@/services/BillingService';
import PriceWithCurrency from '@/components/common/PriceWithCurrency.vue';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import { clientDataService } from '@/services/ClientDataService';

@Component({
  components: { ReportMainChart, PieChart, Datepicker, PriceWithCurrency, DateRangePicker },
})
export default class ReportGenerator extends Vue {
  priceModifier = 0.00001;
  accordions: any = {};
  regions: any = [];
  currency = 'PLN';
  workspaceId = 0;
  format = 'yyyy-MM-dd';
  reportSelect: any = 'custom';
  showDateRangePicker = true;
  language = this.$root.$i18n.locale;
  periods: any = [];
  months: any = [];
  vmSummaryCost = 0;
  dmSummaryCost = 0;
  networkSummaryCost = 0;
  bandwidthSummaryCost = 0;
  backupSummaryCost = 0;
  regionsTotalCost = 0;
  minDate = new Date();
  maxDate = new Date();
  dateRange: any = {
    startDate: startOfMonth(new Date()),
    endDate: new Date(),
  };

  getPolandDateOffset(checkDate: Date | string) {
    let localDate;
    let cestDateStart;
    let cestDateFinish;

    if (new Date().getTimezoneOffset() > 0) {
      localDate = subMinutes(new Date(checkDate), new Date().getTimezoneOffset());
      cestDateStart = subMinutes(new Date(), new Date().getTimezoneOffset());
      cestDateFinish = subMinutes(new Date(), new Date().getTimezoneOffset());
    } else {
      localDate = addMinutes(new Date(checkDate), new Date().getTimezoneOffset());
      cestDateStart = addMinutes(new Date(), new Date().getTimezoneOffset());
      cestDateFinish = addMinutes(new Date(), new Date().getTimezoneOffset());
    }

    const localDateTime = localDate.getTime();

    cestDateStart.setTime(Date.parse('28 March ' + localDate.getFullYear() + ' 02:00:00 GMT+0100'));
    cestDateFinish.setTime(Date.parse('31 October ' + localDate.getFullYear() + ' 03:00:00 GMT+0200'));

    return localDateTime >= cestDateStart.getTime() && localDateTime <= cestDateFinish.getTime() ? 120 : 60;
  }

  mounted() {
    this.months = [
      '',
      this.$t('months.January'),
      this.$t('months.February'),
      this.$t('months.March'),
      this.$t('months.April'),
      this.$t('months.May'),
      this.$t('months.June'),
      this.$t('months.July'),
      this.$t('months.August'),
      this.$t('months.September'),
      this.$t('months.October'),
      this.$t('months.November'),
      this.$t('months.December'),
    ];
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.language = localStorage.getItem('locale') || this.$root.$i18n.locale;

    this.maxDate = new Date(
      addMinutes(new Date(), new Date().getTimezoneOffset() + this.getPolandDateOffset(new Date()))
    );
    this.dateRange.endDate = new Date(
      addMinutes(new Date(), new Date().getTimezoneOffset() + this.getPolandDateOffset(new Date()))
    );
    this.dateRange.startDate = startOfMonth(
      addMinutes(new Date(), new Date().getTimezoneOffset() + this.getPolandDateOffset(new Date()))
    );

    this.getReport(this.dateRange.startDate, this.dateRange.endDate);
    this.getBillingPeriods();
    this.getWorkspaceCreationDate();
  }
  formatDate(date: string) {
    if (!date) {
      return '';
    }

    let displayTimezoneName = this.getPolandDateOffset(date) === 120 ? 'CEST' : 'CET';

    // 2021-03-01T00:00:00+01:00
    let startDate = date.split('T');
    let startDateDate = startDate[0].split('-');

    return `${startDateDate[2]}.${startDateDate[1]}.${startDateDate[0]} ${startDate[1].substring(
      0,
      5
    )} ${displayTimezoneName}`;
  }
  toggleAccordion(name: string) {
    this.accordions[name] = !this.accordions[name];
    this.accordions = { ...this.accordions };
  }
  getAccordionState(name: string) {
    return { active: !!this.accordions[name] };
  }
  getTzDateAsUTC(date: Date) {
    return date ? format(subMinutes(date, this.getPolandDateOffset(date)), 'dd/MM/yyyy HH:mm:ss') + ' +0000' : '';
  }
  getReportFileNameDateFormat(date: Date) {
    return date ? format(date, 'yyyyMMdd') : '';
  }
  tzDateFormat(date: Date) {
    let displayTimezoneName = this.getPolandDateOffset(date) === 120 ? 'CEST' : 'CET';
    return date ? format(date, 'dd.MM.yyyy HH:mm') + ' ' + displayTimezoneName : '';
  }
  getWorkspaceCreationDate() {
    clientDataService
      .getClientData(this.workspaceId)
      .then((data: any) => {
        this.minDate = data.created_at;
        const minDate = new Date(this.minDate);
        if (minDate.getTime() > this.dateRange.startDate.getTime()) {
          this.dateRange.startDate = minDate;
        }
        this.minDate = new Date(subDays(minDate, 1));
      })
      .catch(() => {});
  }
  getDisplayName(name: string) {
    const formattedNames: any = {
      backup_storage: this.$t('backupStorage'),
      storage_hdd: this.$t('diskHDD'),
      storage_ssd: this.$t('diskSSD'),
      win10: this.$t('win10'),
      license_win2016_datacenter_spla: this.$t('win10'),
      ram: 'RAM',
      cpu: 'CPU',
    };
    return formattedNames[name] ? formattedNames[name] : name;
  }
  getReport(dateFrom: any, dateTo: any) {
    if (this.reportSelect !== 'custom') {
      this.showDateRangePicker = false;
      billingService
        .getBillingReport(this.workspaceId, this.reportSelect.id)
        .then((data: any) => {
          this.regions = data.regions;
          this.calculatePrices(this.regions);
          this.currency = data.currency;
        })
        .catch(() => {});
    } else {
      this.showDateRangePicker = true;
      billingService
        .getReport(this.workspaceId, this.getTzDateAsUTC(dateFrom), this.getTzDateAsUTC(dateTo))
        .then((data: any) => {
          this.regions = data.regions;
          this.calculatePrices(this.regions);
          this.currency = data.currency;
        })
        .catch(() => {});
    }
  }
  calculatePrices(regionsData: any) {
    this.regionsTotalCost = 0;
    this.networkSummaryCost = 0;
    this.vmSummaryCost = 0;
    this.dmSummaryCost = 0;
    this.bandwidthSummaryCost = 0;
    this.backupSummaryCost = 0;
    for (let i in regionsData) {
      regionsData[i].addressesTotalCost = 0;
      for (let j in regionsData[i].public_ip_addresses) {
        regionsData[i].addressesTotalCost += regionsData[i].public_ip_addresses[j].cost;
      }
      regionsData[i].dmTotalCost = 0;
      for (let j in regionsData[i].dedicated_machines) {
        regionsData[i].dmTotalCost += regionsData[i].dedicated_machines[j].cost;
      }
      regionsData[i].vmTotalCost = 0;
      for (let j in regionsData[i].virtual_machines) {
        regionsData[i].virtual_machines[j].totalCost = 0;
        for (let k in regionsData[i].virtual_machines[j].periods) {
          regionsData[i].virtual_machines[j].periods[k].totalCost = 0;
          for (let z in regionsData[i].virtual_machines[j].periods[k].resources) {
            if (regionsData[i].virtual_machines[j].periods[k].resources[z].cost) {
              regionsData[i].virtual_machines[j].periods[k].totalCost +=
                regionsData[i].virtual_machines[j].periods[k].resources[z].cost;
            }
          }
          regionsData[i].virtual_machines[j].totalCost += regionsData[i].virtual_machines[j].periods[k].totalCost;
        }
        regionsData[i].vmTotalCost += regionsData[i].virtual_machines[j].totalCost;
      }
      regionsData[i].virtual_machines.sort((machineA: any, machineB: any) => {
        return machineA.id - machineB.id;
      });
      regionsData[i].backupsTotalCost = 0;
      regionsData[i].backupsTotalCount = 0;
      for (let j in regionsData[i].vm_backups) {
        regionsData[i].backupsTotalCost += regionsData[i].vm_backups[j].cost;
        regionsData[i].backupsTotalCount += 1;
      }
      this.regionsTotalCost +=
        regionsData[i].addressesTotalCost +
        regionsData[i].vmTotalCost +
        regionsData[i].dmTotalCost +
        regionsData[i].bandwidth.cost +
        regionsData[i].backupsTotalCost;
      this.networkSummaryCost += regionsData[i].addressesTotalCost;
      this.dmSummaryCost += regionsData[i].dmTotalCost;
      this.vmSummaryCost += regionsData[i].vmTotalCost;
      this.bandwidthSummaryCost += regionsData[i].bandwidth.cost;
      this.backupSummaryCost += regionsData[i].backupsTotalCost;
    }
  }
  getBillingPeriods() {
    billingService
      .getBillingPeriods(this.workspaceId)
      .then((data: any) => {
        this.periods = data.map((item: any) => {
          let startDate = item.start_time.split('T')[0];
          startDate = startDate.split('-');
          item.label = `${this.months[parseInt(startDate[1], 10)]} ${startDate[0]}`;
          return item;
        });
      })
      .catch(() => {});
  }
  getJsonfile(dateFrom: any, dateTo: any) {
    if (this.reportSelect !== 'custom') {
      return billingService
        .getBillingReport(this.workspaceId, this.reportSelect.id)
        .then((data: any) => {
          const blob = new Blob([JSON.stringify(data)], { type: 'text/plain;charset=utf-8' });
          FileSaver.saveAs(
            blob,
            'report_workspace' +
              this.workspaceId +
              '_' +
              this.getReportFileNameDateFormat(new Date(this.reportSelect.start_time)) +
              '_' +
              this.getReportFileNameDateFormat(new Date(this.reportSelect.end_time)) +
              '.json'
          );
        })
        .catch(() => {});
    } else {
      return billingService
        .getReport(this.workspaceId, this.getTzDateAsUTC(dateFrom), this.getTzDateAsUTC(dateTo))
        .then((data: any) => {
          const blob = new Blob([JSON.stringify(data)], { type: 'text/plain;charset=utf-8' });
          FileSaver.saveAs(
            blob,
            'report_workspace' +
              this.workspaceId +
              '_' +
              this.getReportFileNameDateFormat(dateFrom) +
              '_' +
              this.getReportFileNameDateFormat(dateTo) +
              '.json'
          );
        })
        .catch(() => {});
    }
  }
  getCSVfile(dateFrom: any, dateTo: any) {
    if (this.reportSelect !== 'custom') {
      return billingService
        .getBillingReportCSV(this.workspaceId, this.reportSelect.id)
        .then(response => {
          const blob = new Blob([response], { type: 'text/plain;charset=utf-8' });
          FileSaver.saveAs(
            blob,
            'report_workspace' +
              this.workspaceId +
              '_' +
              this.getReportFileNameDateFormat(new Date(this.reportSelect.start_time)) +
              '_' +
              this.getReportFileNameDateFormat(new Date(this.reportSelect.end_time)) +
              '.csv'
          );
        })
        .catch(() => {});
    } else {
      return billingService
        .getCustomReportCSV(this.workspaceId, this.getTzDateAsUTC(dateFrom), this.getTzDateAsUTC(dateTo))
        .then(response => {
          const blob = new Blob([response], { type: 'text/plain;charset=utf-8' });
          FileSaver.saveAs(
            blob,
            'report_workspace' +
              this.workspaceId +
              '_' +
              this.getReportFileNameDateFormat(dateFrom) +
              '_' +
              this.getReportFileNameDateFormat(dateTo) +
              '.csv'
          );
        })
        .catch(() => {});
    }
  }
  getPDFfile(dateFrom: any, dateTo: any) {
    if (this.reportSelect !== 'custom') {
      return billingService
        .getBillingReportPDF(this.workspaceId, this.reportSelect.id)
        .then(response => {
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          FileSaver.saveAs(
            blob,
            'report_workspace' +
              this.workspaceId +
              '_' +
              this.getReportFileNameDateFormat(new Date(this.reportSelect.start_time)) +
              '_' +
              this.getReportFileNameDateFormat(new Date(this.reportSelect.end_time)) +
              '.pdf'
          );
        })
        .catch(() => {});
    } else {
      return billingService
        .getCustomReportPDF(this.workspaceId, this.getTzDateAsUTC(dateFrom), this.getTzDateAsUTC(dateTo))
        .then(response => {
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          FileSaver.saveAs(
            blob,
            'report_workspace' +
              this.workspaceId +
              '_' +
              this.getReportFileNameDateFormat(dateFrom) +
              '_' +
              this.getReportFileNameDateFormat(dateTo) +
              '.pdf'
          );
        })
        .catch(() => {});
    }
  }
}
